import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getIcon } from "@/lib/icons";

export const VerticalCard = ({ vertical }) => {
  const hasImage = !!vertical.image_url;
  return (
    <Link 
      to={`/vertical/${vertical.id}`}
      className="group relative overflow-hidden rounded-2xl bg-white border border-slate-100 shadow-sm card-hover"
      data-testid={`vertical-card-${vertical.id}`}
    >
      {/* Image or gradient fallback */}
      <div className="relative h-48 overflow-hidden">
        {hasImage ? (
          <img 
            src={vertical.image_url}
            alt={vertical.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-700 flex items-center justify-center">
            <div className="text-white/90">
              {getIcon(vertical.icon, "h-20 w-20")}
            </div>
          </div>
        )}
        <div className="vertical-card-overlay absolute inset-0" />
        
        {/* Icon Badge */}
        <div className="absolute top-4 left-4 w-12 h-12 rounded-xl bg-white/90 backdrop-blur-sm flex items-center justify-center text-[#0066CC] shadow-lg">
          {getIcon(vertical.icon, "h-6 w-6")}
        </div>

        {/* Problem Count */}
        {vertical.problem_count > 0 && (
          <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-[#0066CC] text-white text-xs font-medium">
            {vertical.problem_count} Solutions
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-[#0066CC] transition-colors">
          {vertical.name}
        </h3>
        <p className="text-sm text-slate-600 line-clamp-2 mb-4">
          {vertical.description}
        </p>
        <div className="flex items-center text-[#0066CC] text-sm font-medium">
          <span>Explore Solutions</span>
          <ArrowRight className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
};
